module.exports = __webpack_public_path__ + "img/RobecityInternational-hp-top-006.ba97d327.jpg";